import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-relay';

import StravaActivitiesSelection from './StravaActivitiesSelection';
import QueryHandler from '../../misc/QueryHandler';

const StravaActivitiesSelectionQueryRenderer = memo(
  ({
    accessToken,
    isAuthorizationError,
    noStravaActivitiesFoundCallback,
    fileSelectedManually,
    handleFileSelectedManuallyCallback,
    setUpStravaActivity,
    eventDates,
  }) => {
    const stableAccessToken = useMemo(() => accessToken, [accessToken]);

    return (
      <QueryHandler
        hasSmallLoadingSpinner={true}
        query={graphql`
          query StravaActivitiesSelectionQueryRendererQuery(
            $accessToken: String!
            $hasStravaToken: Boolean!
            $before: Date
            $after: Date
          ) {
            stravaActivities(accessToken: $accessToken, before: $before, after: $after)
              @include(if: $hasStravaToken) {
              activities {
                distance
                elapsedTime
                id
                name
                startDate
              }
            }
          }
        `}
        variables={{
          accessToken: stableAccessToken,
          hasStravaToken: Boolean(stableAccessToken),
          before: eventDates.endsAt,
          after: eventDates.beginsAt,
        }}
        render={(props) => {
          return (
            <StravaActivitiesSelection
              stravaActivities={props.stravaActivities}
              isAuthorizationError={isAuthorizationError}
              noStravaActivitiesFoundCallback={noStravaActivitiesFoundCallback}
              fileSelectedManually={fileSelectedManually}
              handleFileSelectedManuallyCallback={handleFileSelectedManuallyCallback}
              setUpStravaActivity={setUpStravaActivity}
            />
          );
        }}
      />
    );
  }
);

StravaActivitiesSelectionQueryRenderer.displayName = 'StravaActivitiesSelectionQueryRenderer';

StravaActivitiesSelectionQueryRenderer.propTypes = {
  accessToken: PropTypes.string,
  isAuthorizationError: PropTypes.bool,
  noStravaActivitiesFoundCallback: PropTypes.func,
  fileSelectedManually: PropTypes.bool,
  handleFileSelectedManuallyCallback: PropTypes.func,
  setUpStravaActivity: PropTypes.func,
  eventDates: PropTypes.shape({
    beginsAt: PropTypes.string,
    endsAt: PropTypes.string,
  }),
  stravaActivities: PropTypes.object,
};

export default StravaActivitiesSelectionQueryRenderer;
